module.exports = __webpack_public_path__ + "img/speedometer_line.cebd55d7.svg";